import { useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useSuggestProject = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/projects/suggest-project`,
        method: "POST",
        body: data,
      }),
  });
};
